import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LocalStorageService } from '@app/@core/services/storage/local-storage.service';
import { TOKEN_STORAGE_KEY } from '@app/@core/services/storage/storage-keys';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "../storage/local-storage.service";
var AuthApiService = /** @class */ (function () {
    function AuthApiService(http, router, storage) {
        this.http = http;
        this.router = router;
        this.storage = storage;
        this.STATUS_UNAUTHORIZED = 401;
        if (environment.hasOwnProperty('apiMockAll') && environment['apiMockAll'] === true) {
            this.apiEndpoint = environment['apiMockEndpoint'];
        }
        else {
            this.apiEndpoint = environment.authServerEndpoint;
        }
    }
    AuthApiService.prototype.get = function (url) {
        return this.resolveApiResponse(this.http.get("" + this.apiEndpoint + url));
    };
    AuthApiService.prototype.post = function (url, options) {
        if (options === void 0) { options = {}; }
        return this.resolveApiResponse(this.http.post("" + this.apiEndpoint + url, options));
    };
    AuthApiService.prototype.put = function (url, options) {
        return this.resolveApiResponse(this.http.put("" + this.apiEndpoint + url, options));
    };
    AuthApiService.prototype.patch = function (url, options) {
        return this.resolveApiResponse(this.http.patch("" + this.apiEndpoint + url, options));
    };
    AuthApiService.prototype.delete = function (url, options) {
        return this.resolveApiResponse(this.http.delete("" + this.apiEndpoint + url, options));
    };
    AuthApiService.prototype.resolveApiResponse = function (data) {
        var _this = this;
        return new Observable(function (observer) {
            data.subscribe(function (response) {
                observer.next(response);
                observer.complete();
            }, function (error) {
                if (error.status === _this.STATUS_UNAUTHORIZED || error.status === 403) {
                    _this.storage.remove(TOKEN_STORAGE_KEY);
                    if (!_this.router.url.includes('/login')) {
                        // TODO: vymazat vsechny puvodni login veci v celem projektu az bude hotove
                        // this.router.navigate(['/login'], {queryParams: {returnUrl: this.router.url}});
                    }
                }
                observer.error(_this.parseErrorResponse(error));
                observer.complete();
            });
        });
    };
    AuthApiService.prototype.parseErrorResponse = function (error) {
        console.log({ error: error });
        var errorResponse = error['error'];
        if (typeof errorResponse === 'string') {
            errorResponse = {
                error: { message: errorResponse }
            };
        }
        if (errorResponse && errorResponse['error'] === undefined) {
            errorResponse['error'] = {};
        }
        if (errorResponse && errorResponse['error']['message'] === undefined) {
            errorResponse['error']['message'] = 'Undefined error';
        }
        return errorResponse;
    };
    AuthApiService.ngInjectableDef = i0.defineInjectable({ factory: function AuthApiService_Factory() { return new AuthApiService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.LocalStorageService)); }, token: AuthApiService, providedIn: "root" });
    return AuthApiService;
}());
export { AuthApiService };
